import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GoogleService } from '../google.service';
import { BiggerThanDateNow } from './../../validators/date-datenow';

import * as _moment from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GoogleEvent } from '../../models/google-models.model';
import { TranslateService } from '@ngx-translate/core';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'sameta-fe-google-new-event',
  templateUrl: './google-new-event.component.html',
  styleUrls: ['./google-new-event.component.scss'],
  standalone: false,
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class GoogleNewEventComponent implements OnInit {
  @Input() emailAddress = '';
  form: FormGroup;
  cancelMsg: string;
  statusMsg: string;
  @Output() eventCreated: EventEmitter<GoogleEvent> = new EventEmitter();

  constructor(private fb: FormBuilder, private googleService: GoogleService, private snackBar: MatSnackBar, private translate: TranslateService) {}

  ngOnInit(): void {
    let endDate = new Date();
    endDate.setHours(endDate.getHours() + 1);
    this.form = this.fb.group({
      startT: this.fb.control('', Validators.required),
      startD: this.fb.control('', Validators.required),
      endD: this.fb.control('', Validators.required),
      endT: this.fb.control('', Validators.required),
      title: this.fb.control('', Validators.required),
      description: this.fb.control('', {}),
      attendees: this.fb.control(this.emailAddress, {}),
    });
  }

  createEvent() {
    if (this.form.valid) {
      const formValues = {
        title: this.form.value.title,
        description: this.form.value.description,
        start: this.mergeDateTime(this.form.value.startD, this.form.value.startT),
        end: this.mergeDateTime(this.form.value.endD, this.form.value.endT),
        // colorID: String(this.form.value.color),
        id: '',
        attendees: this.form.value.attendees,
      };

      this.googleService.createEvent(formValues).subscribe((res) => {
        this.eventCreated.emit(res.body);
      });
    } else {
      this.eventCreated.emit(null);
      this.translate.get('shared.incorrectFields', { value: '' }).subscribe((resp: string) => {
        this.statusMsg = resp;
      });
      this.translate.get('shared.cancel', { value: '' }).subscribe((resp: string) => {
        this.cancelMsg = resp;
      });
      this.snackBar.open(this.statusMsg, this.cancelMsg, {
        duration: 3000,
      });
    }
  }

  cancel() {
    this.eventCreated.emit(null);
  }

  mergeDateTime(date: string, time: string): Date {
    const yy = new Date(date).getFullYear();
    const mm = new Date(date).getMonth();
    const dd = new Date(date).getDate();

    var interMedDt = new Date(yy, mm, dd);
    interMedDt.setHours(Number(time.split(' ')[0].split(':')[0]));
    interMedDt.setMinutes(Number(time.split(' ')[0].split(':')[1]));

    return interMedDt;
  }
}
